import { usePatientPdfDownload } from "features/patients/hooks/usePatientPdfDownload";

export const useDownloadPatientReport = () =>
  usePatientPdfDownload({
    fallbackFilename: (patientId) => `patient-report-${patientId}.pdf`,
    failureMessage: "Failed to download patient report",
  });
